import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-content">
        <h1>Sobre Mi</h1>
        <p>
          Soy médica clínica formada en la Universidad Nacional del Centro de la Provincia de Buenos Aires (UNICEN). Realicé mi residencia médica en Tandil, ciudad donde elijo ejercer y vivir. Mi matrícula profesional es M.P. 82147.
        </p>
        <p>
          Actualmente, me desempeño como médica en la Unidad de Cuidados Intermedios del Hospital Ramón Santamarina de Tandil.
        </p>
        <p>
          Además, brindo atención clínica particular en Consultorios Médicos Colón y en Centro Médico Taien, donde busco acompañarte en la prevención y el cuidado integral de tu salud.
        </p>
      </div>
    </section>
  );
};

export default About;
